import React from "react";
import { useMediaQuery } from 'react-responsive';

import "./styles/text.css"

const date = new Date();

function Copyright() {
  const isMobileLarge = useMediaQuery({ query: '(height > 1616px)' });

  return (
    <div>
      <p className={`textRegularCentered ${isMobileLarge ? "fontSize25px" : "fontSize15px"}`}>
        © {date.getFullYear()} Razul Artworks.
      </p>
      <p className={`textRegularCentered ${isMobileLarge ? "fontSize25px" : "fontSize15px"}`}>
        All rights reserved.
      </p>
    </div>
  );
}

export default Copyright;
